var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.833 17.637a10.668 10.668 0 00-15.127-13.4L7.383 1.921a13.328 13.328 0 0113.283.032c5.987 3.456 8.28 10.856 5.49 17.027l1.789 1.032-5.554 2.952-.22-6.285 1.662.958zM4.166 9.363a10.668 10.668 0 0015.127 13.4l1.322 2.316a13.328 13.328 0 01-13.282-.032C1.346 21.59-.947 14.19 1.843 8.02L.053 6.99l5.553-2.953.22 6.286-1.661-.96h.001zm5.167 6.804h7.333a.667.667 0 100-1.334h-5.333a3.333 3.333 0 010-6.666h1.333V6.833h2.667v1.334h3.333v2.666h-7.333a.667.667 0 000 1.334h5.333a3.333 3.333 0 010 6.666h-1.333v1.334h-2.667v-1.334H9.333v-2.666z",
    fill: "#F8FAFF"
  })));
}
export default SvgSpav;